/**
 * id numbers for symbols that display values
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

export const valueIds: number[] = [9, 10, 11, 12, 13]

export const jackpotIds: number[] = [11, 12, 13]
export const collectorIds: number[] = [10]
export const scatterIds: number[] = [9]

export const displayedValues: number[] = [9, 10]
